import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import PageHeader from "../Components/PageHeader";
import SignUpTabs from "../Components/SignUpTabs";
import Select from "react-select";

const PhysicianSignUpDetail = () => {
	const specializationOptions = [
		{ value: "pediatrics", label: "Pediatrics" },
		{ value: "neurology", label: "Neurology" },
		{ value: "adnarology", label: "adnarology" },
		{ value: "sharicology", label: "sharicology" },
		{ value: "adnarology1", label: "adnarology1" },
		{ value: "sharicology1", label: "sharicology1" },
	];

	const [selectedSpecializations, setSelectedSpecializations] = useState(
		"Area of Specialization",
	);

	const handleChange = (selectedOptions) => {
		setSelectedSpecializations(selectedOptions);
	};

	// upload file

	const [selectedFile, setSelectedFile] = useState(null);

	const handleFileChange = (e) => {
		const file = e.target.files[0];
		setSelectedFile(file);
		// You can perform additional actions here, such as uploading the file.
	};
	return (
		<>
			<Header />
			<PageHeader pagename="SignUp" />
			<section className="signup">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 mx-auto">
							<div className="signup-wrappper">
								<h2 className="main-heading-font dark-color  level-2 text-center mt-3  mb-4">
									Sign up
								</h2>
								<div className="row mt-3">
									<div className="col-lg-12">
										<div className="d-flex align-items-center justify-content-center">
											<SignUpTabs />
										</div>
									</div>
								</div>
								<form>
									<div className="row">
										<div className="col-lg-12">
											<div>
												<form>
													<Select
														isMulti
														name="specializations"
														isSearchable={false}
														options={specializationOptions}
														className="basic-multi-select"
														classNamePrefix="select"
														onChange={handleChange}
														value={selectedSpecializations}
														placeholder="Area of Specialization"
													/>
												</form>
											</div>
										</div>
									</div>
									<div className="row mt-3">
										<div className="form-group col-lg-12">
											<label htmlFor="">
												<h5 className="primary-medium-font level-7 ">
													Enter Years of Experience
												</h5>
												<input
													type="text"
													className="form-control"
													id="firstName"
													placeholder=" Years of Experience"
												/>
											</label>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-12">
											<label htmlFor="">
												<h5 className="primary-medium-font level-7 ">
													Enter Degree Title
												</h5>
												<input
													type="text"
													className="form-control"
													id="firstName"
													placeholder="Degree Title"
												/>
											</label>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-12">
											<label htmlFor="">
												<h5 className="primary-medium-font level-7 ">
													Enter License Number
												</h5>
												<input
													type="number"
													className="form-control"
													id="firstName"
													placeholder="License Number"
												/>
											</label>
										</div>
									</div>
									<div className="row">
										<div className="col-lg-12">
											<div className="upload-input-signup">
												<div className="upload-icon-signup">
													<i className="fa-solid fa-user"></i>
												</div>
												<label
													htmlFor="uploadfile"
													className="custom-file-label"
												>
													{selectedFile
														? selectedFile.name
														: "Upload Profile Image"}
												</label>
												<input
													type="file"
													id="uploadfile"
													className="form-control"
													onChange={handleFileChange}
												/>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-lg-12">
											<Link
												class="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
												to="/physician-availablity"
											>
												<span class="bg-wrapper w-100">Sign Up</span>
											</Link>
										</div>
									</div>
								</form>
							</div>
							<h4 class=" level-7 text-center mt-3  primary-regular-font text-decoration-none extra-color-1">
								By Becoming a member, you agree to our{" "}
								<Link
									class="header-link level-7 link-here primary-medium-font text-decoration-none extra-color-1"
									href="/"
								>
									<span className="primary-semibold-font">
										{" "}
										Terms & Conditions{" "}
									</span>{" "}
								</Link>
							</h4>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PhysicianSignUpDetail;
